import { createTypes, asyncAction } from 'redux-action-types';
import { createAction } from 'redux-actions';
import { NEXO_NAMESPACE } from '../../helpers/constants';

export const types = createTypes(
  NEXO_NAMESPACE,
  asyncAction('LOAD_IPM_CONTENT'),
  'SET_IPM_CONTENT',
  'CLEAR_IPM_CONTENT',
);

const loadIpmContent = createAction(types.LOAD_IPM_CONTENT_REQUEST);

const setIpmContent = createAction(
  types.SET_IPM_CONTENT,
  (ipmContent, ipmContentLoaded) => ({
    ipmContent,
    ipmContentLoaded,
  }),
);

const clearIpmContent = createAction(types.CLEAR_IPM_CONTENT);

export const actions = {
  loadIpmContent,
  setIpmContent,
  clearIpmContent,
};
